"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.wrapLink = void 0;
const slate_1 = require("slate");
const wrapLink = (editor, selection, data) => {
    slate_1.Transforms.select(editor, selection);
    slate_1.Editor.addMark(editor, 'link', data);
};
exports.wrapLink = wrapLink;
//# sourceMappingURL=wrap-link.js.map